module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isDeleted) ? _c('section', {
    staticClass: "post"
  }, [_c('div', {
    staticClass: "poster-details"
  }, [_c('span', {
    staticClass: "poster-alias"
  }, [_c('router-link', {
    attrs: {
      "to": ("/Developer/" + (_vm.post.posterData.stringUrl))
    }
  }, [_vm._v(_vm._s(_vm.post.posterData.alias))])], 1), _vm._v(" "), _c('div', {
    staticClass: "avatar-container"
  }, [_c('avatar', {
    attrs: {
      "profile-data": _vm.post.posterData,
      "profile-type": "developer",
      "size": "large",
      "show-xp-info": true
    }
  })], 1)]), _vm._v(" "), (!_vm.editPostMode && !_vm.deletePostMode) ? _c('div', {
    staticClass: "content-details"
  }, [_c('markdown-content', {
    attrs: {
      "content": _vm.post.content,
      "classes": "content"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "time-stamp"
  }, [_vm._v("Posted " + _vm._s(_vm._f("formatDate")(_vm.post.created)))]), _vm._v(" "), _c('div', {
    staticClass: "post-details"
  }, [_c('span', [(!_vm.editPostMode && !_vm.deletePostMode) ? _c('voting-widget', {
    attrs: {
      "parent-type": "forum",
      "parent-id": _vm.post.id,
      "initial-points": "0"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.isPoster) ? _c('span', {
    staticClass: "edit-post",
    on: {
      "click": function($event) {
        _vm.editPostMode = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-pencil-alt"
  }), _vm._v(" Edit Post")]) : _vm._e(), _vm._v(" "), (_vm.isPoster) ? _c('span', {
    staticClass: "delete-post",
    on: {
      "click": function($event) {
        _vm.deletePostMode = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  }), _vm._v(" Delete Post")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.editPostMode) ? _c('div', {
    staticClass: "edit-post-form"
  }, [(_vm.isSaving) ? _c('saver-large') : _vm._e(), _vm._v(" "), (!_vm.isSaving) ? [_c('markdown-editor', {
    model: {
      value: (_vm.editPostContent),
      callback: function($$v) {
        _vm.editPostContent = $$v
      },
      expression: "editPostContent"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button minor",
    on: {
      "click": function($event) {
        _vm.editPostMode = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.saveEditedPost
    }
  }, [_vm._v("Save Changes")])] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.deletePostMode) ? _c('div', {
    staticClass: "delete-post-form"
  }, [_c('button', {
    staticClass: "button minor",
    on: {
      "click": function($event) {
        _vm.deletePostMode = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.deletePost
    }
  }, [_vm._v("Delete Post")])]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-495559da!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Common/Forums/ForumsPost.vue
// module id = 866
// module chunks = 2